export enum LockerEventStatus {
    FAILED = 0,
    WITHERRORS = 10,
    PROCESSING = 20,
    COMPLETED = 30
}

export enum LockerContextRefreshType {
    ALL='all',
    EVENTS='events',
    ARCHIVE='archive',
    BATCHES='batches',
    ERRORS='errors',
}

export enum Month {
    UNKNOWN,
    JANUARY,
    FEBRUARY,
    MARCH,
    APRIL,
    MAY,
    JUNE,
    JULY,
    AUGUST,
    SEPTEMBER,
    OCTOBER,
    NOVEMEMBER,
    DECEMBER
}


export interface LockerFilesBatch {
    id: number,
    batchname: string
    lastupdate: string
    files: number
    users: number
    uniqueOpens: number
    createDate: string
    removedDate: string
    removedBy: string
}

export interface LockerEvents {
    id: number,
    batchname: string
    lastupdate: string
    files: number
    users: number
    uniqueOpens: number
    CreateDate: string
    removedDate: string
    removedBy: string
    status: LockerEventStatus
    LockerBatchId: number
}

export interface SearchAndFilterParams {
    table? :  LockerContextRefreshType
    searchTerm?: string
    filter?: string | number
    skip?: number
    sortBy?: string
    sort?: string
}

export interface DDOptions {
    value: any
    label: string
}

export interface LockerBatchResponse {
    batches: LockerBatch[] | LockerEvent[]
    previousSkip: number,
    nextSkip: number,
    totalfiles: number
}

export interface LockerEvent {
    lockerBatchId: number,
    lockerBatchName: string,
    uploadDate?: string,
    intentAliasCount: number,
    intentFileCount: number,
    lockerBatchStatus: number
}

export interface LockerBatch {
    batchId: number
    batchName: string
    lastUpdate: string
    files: number
    users: number
    removedByUserName: string
    lastArchiveActionDate: string
    nonArchivedFiles: number
    nonArchivedUsers: number
    archivedFiles: number
    archivedFileUsers: number 
}

export interface ModalProps {
    title?: string
    confirmLabel?: string
    cancelLabel?: string
    onClose: () => void
    onConfirm: (...args: any[]) => void
    contents?: JSX.Element | JSX.Element[] | string
    id?: number
}

export interface LockerHighlightsResponse {
    filesReceived: number
    uniqueOpens: number
    filesSuccessfullySent: number
    failures: number
}

export interface MoreDetailsResponse {
    batchId:number
    batchName:string,
    dateCreated:string,
    mostRecentBatchUpdate:string, 
    fileCount:number, 
    userCount:number, 
    uniqueOpens:number 
}

export interface Users {
    id: number
    jobTitle: number
    name: string
    profilePicUrl: string
    displayName: string
    department: string
}

export interface Groups {
    groupName: string
    totalUsersInGroup: number
}

export interface LockerSecuritySettings {
    setupProtectionWindowInDays: number
    onboardingWindowInDays: number
    lastUpdatedDate: string
    lastUpdatedBy: string
}

export interface ErrorDetails {
    batchId: number
    batchName: string
    downloadURI: string
    issueCount: number
    issueDescription: string
    lockerIntentFileDeliveryRequestDetailedStatus: number
}

export interface Errors {
    batchId: number,
    batchName: string,
    lockerBatchErrorsDetailsRecord: ErrorDetails []
}